<template>
  <div>
    <div v-if="error" class="alert alert-danger" role="alert">
      {{ error }} <button class="btn btn-sm btn-outline-danger" @click="loadMode">Retry</button>
    </div>
    <RevisionPage v-else-if="enabled === true" />
    <LegacyPage v-else-if="enabled === false" />
    <div v-else class="p-3" role="status">Loading...</div>
  </div>
</template>

<script>
import LegacyPage from '../../components/Localization/LegacyPage.vue';
import RevisionPage from '../../components/Localization/RevisionPage.vue';

export default {
  components: {LegacyPage, RevisionPage},
  data: () => ({enabled: null, error: ''}),
  methods: {
    async loadMode() {
      this.error = '';
      try {
        const response = await this.$http.get('/api/v1/localization/workflow');
        this.enabled = response.data.enabled === true;
      } catch (error) {
        // A rolling deployment may still serve the pre-gate backend.
        if (error.response && error.response.status === 404) this.enabled = false;
        else this.error = 'Unable to load localization workflow.';
      }
    },
  },
  mounted() { this.loadMode(); },
};
</script>
